// extracted by mini-css-extract-plugin
export default {"label":"inputLabel_label__oPmXZ","has-values":"inputLabel_has-values__N09f0","no-move":"inputLabel_no-move__C0JG7","custom":"inputLabel_custom__r7MDb"};